<template>
    <div>
        <rkm-data-table
            :fields="fields.datatables.historico"
            :filter="localFilter"
            :repository="repositories.pacienteBusca"
            :search-by="localSearchOption"
            :reset-table="resetTable"
            :search-table="searchTable"
            ref="RkmDataTable"
            sort-by="data"
            sort-desc
        >
            <template v-slot:filters>
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidade"
                            disabled
                            label="Unidade"
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestrutura"
                            disabled
                            label="Local de atendimento"
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-input
                            placeholder="Digite para buscar"
                            v-model="localFieldFilter"
                            @keyup.native.enter="handleEnterKey"
                        >
                            <rkm-input-group-prepend slot="prepend">
                                <rkm-form-select
                                    :options="searchOptions"
                                    class="m-0"
                                    v-model="localSearchOption"
                                />
                            </rkm-input-group-prepend>

                            <rkm-input-group-append slot="append">
                                <rkm-button
                                    @click="search"
                                    color="primary"
                                    class="btn-search"
                                >
                                    Buscar
                                </rkm-button>
                                <rkm-button
                                    :disabled="!localFieldFilter"
                                    @click="clear"
                                    class="btn-clear"
                                >
                                    Limpar
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:cell(pacienteNome)="row">
                <rkm-button
                    class="mr-2"
                    color="secondary"
                    small
                    v-rkm-popover.hover.left="
                        {
                            title: 'Dados cadastrais',
                            html: true,
                            content:
                                '<b>Prontuário:</b> ' + (row.item.prontuario || '') + '<br/>' +
                                '<b>Data de Nascimento:</b> ' + row.item.dataNascimento + '<br/>' +
                                '<b>Nome da Mãe:</b> ' + row.item.nomeMae + '<br/>'
                        }
                    "
                >
                    <rkm-icon icon="user" />
                </rkm-button>

                <span v-if="!row.item.sequencialDesconhecido">
                    {{row.item.pacienteNome}}

                    <template v-if="row.item.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{row.item.nomeSocial}})</strong>
                    </template>
                </span>

                <span
                    v-else
                    class="text-primary"
                    v-rkm-popover.hover.top="
                        {
                            title: 'Características físicas',
                            content: row.item.caracteristicasFisicas
                        }
                    "
                >
                    {{row.item.pacienteNome}}
                </span>
            </template>

            <template v-slot:cell(desfecho)="row">
                <span v-if="row.item.desfecho">{{row.item.desfecho}}</span>
                <span v-else>-</span>
            </template>

            <template v-slot:cell(setorAtual)="row">
                <span v-if="row.item.setorAtual">{{row.item.setorAtual}}</span>
                <span v-else>-</span>
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    :id="uniqueId('show-btn')"
                    @click="$refs.ModalBusca.open(row.item)"
                    color="primary"
                    small
                    title="Histórico Atendimento"
                >
                    <rkm-icon icon="history" />
                </rkm-button>

                <rkm-button
                    :disabled="!isDisableRealocar(row.item) || !!row.item.finalizado || !!row.item.cancelado"
                    @click="realocar(row.item)"
                    authorize="realocar-pronto-atendimento-paciente-busca"
                    color="warning"
                    small
                    title="Realocar"
                >
                    <rkm-icon icon="walking" />
                </rkm-button>


                <rkm-button
                    :disabled="DisableDelete(row.item) || !!row.item.cancelado"
                    @click.stop="handleDestroy(row.item)"
                    authorize="destroy-pronto-atendimento-paciente-busca"
                    color="danger"
                    small
                    title="Excluir Atendimento"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>

            </template>
        </rkm-data-table>

        <ModalBusca ref="ModalBusca" />

        <ModalSetor
            :centros-custo="form.centrosCustoEncaminhamento"
            ref="ModalSetor"
        />
    </div>
</template>

<script>
// Components.
import ModalBusca from '@/components/pronto-atendimento/paciente-busca/components/Modal'
import ModalSetor from './components/setor/Modal'

// Mixins.
import { error, repository } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import tipoSetor from '@/enums/cadastro/estabelecimento/setorTipo'

export default {
    components: { ModalBusca, ModalSetor },
    computed: {
        ...mapGetters({ lotacao: 'getLotacao' }),
        fields() {
            return {
                datatables: {
                    historico: [
                        {
                            key: 'data',
                            label: 'Data',
                            name: 'data',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            key: 'hora',
                            label: 'Início do atendimento',
                            name: 'hora',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            key: 'faaNumero',
                            label: 'FAA',
                            name: 'prontoAtendimentoFaa.numero',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            key: 'pacienteNome',
                            label: 'Paciente',
                            name: 'cadastroCidadao.nome',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            key: 'setorAtual',
                            label: 'Setor',
                            name: 'setorAtual',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            key: 'desfecho',
                            label: 'Desfecho',
                            name: 'desfecho',
                            sortable: true,
                        },
                        {
                            class: 'col-min text-center',
                            key: 'actions',
                            label: 'Ações',
                        },
                    ],
                },
            }
        },
        searchOptions() {
            return this.fields.datatables.historico.filter(field => !!field.searchable).map(field => {
                return { text: field.label, value: field.key }
            })
        },
    },
    created() {
        this.repositories = {
            pacienteBusca: this.getConectaSusRepository('prontoAtendimento.pacienteBusca')
        }
    },
    data: () => ({
        localFieldFilter: null,
        localFilter: null,
        localSearchOption: 'pacienteNome',
        resetTable: false,
        searchTable: false,
        form: {
            unidade: [],
            infraestrutura: [],
            centrosCustoEncaminhamento: [],
        },
        model: {
            unidadeId: null,
            infraestruturaId: null,
            filter: null,
        },
        enums: { preferenciaNome, tipoSetor }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.form.unidade =  [{
                id: this.lotacao.infraestrutura.unidade.id,
                nomeFantasia: this.lotacao.infraestrutura.unidade.nomeFantasia,
            }]

            this.form.infraestrutura = [{
                id: this.lotacao.infraestrutura.id,
                nome: this.lotacao.infraestrutura.nome,
            }]

            this.model.unidadeId = this.lotacao.infraestrutura.unidade.id
            this.model.infraestruturaId = this.lotacao.infraestrutura.id

            this.setLoading()

            this.repositories.pacienteBusca.create()
                .then(({ data }) => {

                    this.form.centrosCustoEncaminhamento = data.form.centrosCustoEncaminhamento
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        realocar(item) {
            const realocar = (centroCustoId) =>
                this.repositories.pacienteBusca.realocar(item.faaId, { centro_custo_id: centroCustoId })
                    .then(() => {
                        this.showSaveNotification()
                        this.refreshTable()
                    })
                    .catch(this.handleError)

            this.showConfirmation(`Deseja realmente realocar o atendimento do(a) paciente ${item.pacienteNome}?`,
                async () => {

                    this.$refs.ModalSetor.open(item.centroCustoId, realocar)
                }
            )
        },
        DisableDelete(item) {
            return item.faaCancelada !== null || (item.procedimento_id !== null && !!item.bloqueado);
        },
        isDisableRealocar(item){
            return !item.faaCancelada;
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.pacienteBusca.destroy(item.faaId)
                .then(() => this.refreshTable())

            this.showDeleteConfirmation(
                `O atendimento do paciente ${item.pacienteNome} será excluído e não poderá ser recuperado. Deseja continuar?`,
                destroy,
                this.handleError
            )
        },
        search() {

            this.searchTable = true
            this.resetTable = false
            this.localFilter = this.localFieldFilter
            this.$refs.RkmDataTable.refresh();
        },
        refreshTable(){

            this.clearTable()
            this.$nextTick(() => this.search());
        },
        clear() {
            this.localSearchOption = 'pacienteNome';
            this.clearSearchOption()
        },
        clearSearchOption() {
            this.localFieldFilter = null
            this.clearTable()
        },
        clearTable() {
            this.localFilter = null
            this.resetTable = true
            this.searchTable = false
        },
        handleEnterKey(event) {

            if (event.key === 'Enter') {
                this.search();
            }
        },
    },
    mixins: [ error, repository ],
    mounted() {

        if (this.searchOptions.length > 0) {
            this.localSearchOption = 'pacienteNome';
        }

        this.load()
    },
    watch: {
        filter(value) {
            this.localFilter = value
        },
        'localSearchOption': function () {

            this.clearSearchOption()
        },
        'localFieldFilter': function () {

            this.clearTable()
        },
    },
}
</script>

<style scoped>
.btn-search {
    border-top-right-radius: 0.25rem!important;
    border-bottom-right-radius: 0.25rem!important;
}
.btn-clear {
    border-top-left-radius: 0.25rem!important;
    border-bottom-left-radius: 0.25rem!important;
}
</style>
